<script>
	import '$lib/app.css';
	import Pixels from '$lib/Components/Pixels/Pixels.svelte';
	import { estimateForm } from '$lib/PageSections/Forms/Estimate/estimate.svelte.js';
	import Header from '$lib/PageSections/Header/Header.svelte';
	import {
		uiState,
		userData,
	} from '$lib/PageSections/Portal/userData.svelte.js';
	import { setContext } from 'svelte';
	import { Toaster } from 'svelte-french-toast';
	import { writable } from 'svelte/store';

	let { children, data } = $props();

	setContext('sessionData', { user: writable({}) });
	setContext('userData', userData);
	setContext('uiState', uiState);
	setContext('estimateForm', estimateForm);
	setContext('experimentGroup', data.experimentGroup);
</script>

<Pixels />

<Toaster />
<Header />
{@render children?.()}
